import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserDetails } from '../../../zustand';
import { ExtensionIcon } from '../../../helpers/icons';

const PendingExtensionsIcon = () => {
  const navigate = useNavigate();
  const { pending_extension = null } = useUserDetails(
    (s) => s.userDetails || {},
  );

  return (
    <div
      className="position--relative c--pointer"
      data-tooltip="Pending Extensions"
      tooltip-position="left"
    >
      <span
        className="text--primary bg--primary-50 p--sm radius--full w-min--36 w-max--36 h-min--36 h-max--36 d--flex align-items--center justify-content--center"
        onClick={() => navigate('/pending-extensions')}
      >
        <ExtensionIcon width={20} height={20} />
      </span>
      {Boolean(parseInt(pending_extension)) ? (
        <div className="count-badge position--absolute top--0 right---5 font--xs font--600 bg--danger text--white">
          {pending_extension}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default PendingExtensionsIcon;
